import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { FunctionsService } from '../services/functions.service';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AddActivityComponent } from './add-activity/add-activity.component';
import { PaginationModel } from '../models/paginationModel';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-alert-log-component',
  templateUrl: './alert-log.component.html',
  styleUrls: ['./alert-log.component.css'],
  providers: [NgxSpinnerService]
})

export class AlertLogComponent implements OnInit {
  modalOptions: NgbModalOptions = {};
  alertId = 0;
  agentId = 0;
  userId = 0;
  alertStatus = 1;
  totalLength = 0;
  pageIndex = 0; 
  pageSize = 5;
  chatMessages: Array<any> = [];
  logs:any;
  language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
  filter: any;
  role: any;
  currentUserId: any;
  expired: any;
  @ViewChild('paginator') paginator: MatPaginator;

  constructor(
    private activatedRoute:ActivatedRoute,
    private apiService: ApiService,
    public functionsService: FunctionsService,
    private spinner:NgxSpinnerService,
    private modalService: NgbModal,
    private angularFireStore: AngularFirestore,
    public pagination: PaginationModel,
    private translate: TranslateService,
    private router: Router
    ) { 
      this.activatedRoute.params.subscribe(params => {
        this.pagination.AlertId = params['alertId'];
      });
      this.logs = [];
    }

   async ngOnInit() {
    this.role = await this.functionsService.getRole();
    this.currentUserId = await this.functionsService.getUserId();
    this.expired = await this.functionsService.isExpired();
    this.functionsService.setTitle('alert.activity');
    if(localStorage.getItem('language') != null){
      this.functionsService.useLanguageRed(this.language);
    }
    this.pagination.ChatHistory = false;
    this.fetchAlertLogs(); 
  }

  fetchAlertLogs(){
    this.spinner.show();
    this.logs = [];
    this.pagination.Filter = this.filter;
    this.pagination.Page = this.pageIndex;
    this.pagination.PageSize = this.pageSize;
    this.apiService.getAlertLogs(this.pagination).subscribe(
      data => { 
        this.totalLength = data["totalLength"];
                if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                    document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
                    this.translate.onLangChange.subscribe(() => {
                        document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
                    });
            }
        this.agentId = data["alert"]["attendedBy"];
        this.alertStatus = data["alert"]["status"];
        this.userId = data["alert"]["createdBy"];
        let jsonString = JSON.stringify(data);
        let jsonObject = JSON.parse(jsonString);
          var i = 0;
          var k = 0;
          while((i<jsonObject["alertLog"].length)){
            if(jsonObject["alertLog"][i]){
              var newDate = new Date(jsonObject["alertLog"][i].eventDate+"Z");

              //var messageDate = new Date(chat1[j]["timestamp"])
              if(newDate.getTime()){
                this.logs[k] = [];
                if(jsonObject["alertLog"][i].name == null){
                  this.logs[k][0] = null;
                  var params = (jsonObject["alertLog"][i].description.split(","));
                  this.logs[k][1] = {name: params[0], pastAlertType: params[1], newAlertType: params[2]};
                }
                else if(jsonObject["alertLog"][i].name == "attend_timer" || jsonObject["alertLog"][i].name == "close_timer"){
                  this.logs[k][0] = jsonObject["alertLog"][i].name;
                  var params = (jsonObject["alertLog"][i].description.split("."))
                  this.logs[k][1] = {days: params[0], time: params[1]};
                }
                else{
                this.logs[k][0] = this.translate.instant("alert_activity."+jsonObject["alertLog"][i].name);
                this.logs[k][1] = jsonObject["alertLog"][i].description == "" ? "" : this.translate.instant(jsonObject["alertLog"][i].description);
                }
                this.logs[k][2] = this.functionsService.convertUTCDateToLocalDate(jsonObject["alertLog"][i].eventDate);
                this.logs[k][3] = "4";
                i++;
              }
              k++;
            }
            else if(jsonObject["alertLog"][i]){
              this.logs[k] = [];
              if(jsonObject["alertLog"][i].name == null){
                this.logs[k][0] = null;
                var params = (jsonObject["alertLog"][i].description.split(","));
                this.logs[k][1] = {name: params[0], pastAlertType: params[1], newAlertType: params[2]};
              }
              else if(jsonObject["alertLog"][i].name == "attend_timer" || jsonObject["alertLog"][i].name == "close_timer"){
                this.logs[k][0] = jsonObject["alertLog"][i].name;
                var params = (jsonObject["alertLog"][i].description.split("."))
                this.logs[k][1] = {days: params[0], time: params[1]};
              }
              else{
              this.logs[k][0] = this.translate.instant("alert_activity."+jsonObject["alertLog"][i].name);
              this.logs[k][1] = jsonObject["alertLog"][i].description == "" ? "" : this.translate.instant(jsonObject["alertLog"][i].description);
              }
              this.logs[k][2] = this.functionsService.convertUTCDateToLocalDate(jsonObject["alertLog"][i].eventDate);
              this.logs[k][3] = "4";
              i++;
              k++;
            }
          }
          if(this.logs.length == 0 && this.filter == "notes"){
            this.logs[0] = [];
            this.logs[0][0] = "alert_activity.notes_empty";
            this.logs[0][1] = "";
          }
          this.spinner.hide();
        });
          
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      };
  }

  refreshLogs(){
    if(this.filter == "notes"){
      this.paginator.pageIndex = 0;
      this.paginator._changePageSize(5);
    }
    this.fetchAlertLogs();
  }

  nextPage(evt){
    this.pageIndex = evt.pageIndex;
    this.pageSize = evt.pageSize;
    this.fetchAlertLogs();
  }

  async openAddActivity() {
    if((this.alertStatus!=1)&&((this.agentId.toString()==this.currentUserId&&await this.role=='SecurityAgent')||(!['Admin','SecurityAgent'].includes(this.role))||(this.role=="SecurityAgent" && this.alertStatus == 3))&&this.userId.toString()!=this.currentUserId){
      const modalRef = this.modalService.open(AddActivityComponent, { size: 'lg' });
      modalRef.componentInstance.alertInfo = this.pagination.AlertId;
      modalRef.result.then(() => this.fetchAlertLogs());
    }else {
      this.functionsService.errorHandler(401);
    }
  }

  chatLog(){
    this.router.navigateByUrl('alertLog/'+ this.pagination.AlertId + '/chat');
  }

  applyFilter(checked){
    this.filter = checked? "notes" : "";
    this.paginator.pageIndex = 0;
    this.paginator._changePageSize(5);
    this.fetchAlertLogs();
  }
}


